import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';

export const useDynamicDashboardStore = defineStore('dynamicDashboard', {
    state: () => ({
        id: null,
        data: {},
        isLoading: false,
        error: null,
    }),
    actions: {
        setIdFromRoute() {
            const route = useRoute();
            this.id = route.params.id;
        },

        async fetchData(endpoint) {
            this.isLoading = true;
            this.error = null;
            try {
                // Update the base URL and endpoint as needed
                const response = await fetch(`https://rwnbpxpxauytxfuuffsg.supabase.co/functions/v1/${endpoint}/${this.id}`);
                const data = await response.json();
                if (data) {
                    this.data[endpoint] = data;
                } else {
                    this.data[endpoint] = [];
                }
            } catch (err) {
                this.error = `Failed to fetch data from ${endpoint}`;
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },

        async fetchCompetitorCount() {
            // This specifically fetches the competitor count endpoint
            const endpoint = 'competitor-detail/wettbewerber/count';
            await this.fetchData(endpoint);
        },
        async fetchActionTypeCounts() {
            const endpoint = 'competitor-detail/wettbewerber/action-type-counts';
            await this.fetchData(endpoint);
        },
        // New action to fetch competitor incentive data
        async fetchCompetitorIncentive() {
            const endpoint = 'competitor-detail/wettbewerber/incentive';
            await this.fetchData(endpoint);
        },

        // New action to fetch 'rabatthoehe' data
        async fetchRabatthoehe() {
            const endpoint = 'competitor-detail/wettbewerber/rabatthoehe';
            await this.fetchData(endpoint);
        },
        async fetchAverageRuntimeDays() {
            const endpoint = 'competitor-detail/wettbewerber/average-runtime-days';
            await this.fetchData(endpoint);
        },
        // In your Pinia store
        async fetchDiscountDistribution() {
            const endpoint = 'competitor-detail/wettbewerber/discount-distribution';
            await this.fetchData(endpoint);
        },

        async fetchDiscountDistributionBisZu() {
            const endpoint = 'competitor-detail/wettbewerber/discount-distribution-bis-zu';
            await this.fetchData(endpoint);
        },

        // New actions for the three endpoints used in the pie charts
        async fetchMovStatusPercentage() {
            const endpoint = 'competitor-detail/wettbewerber/mov-status-percentage';
            await this.fetchData(endpoint);
        },

        async fetchVoucherCodeStatusPercentage() {
            const endpoint = 'competitor-detail/wettbewerber/voucher-code-status-percentage';
            await this.fetchData(endpoint);
        },

        async fetchIncentivierungExtraCounts() {
            const endpoint = 'competitor-detail/wettbewerber/incentivierung-extra-counts';
            await this.fetchData(endpoint);
        },

        // New endpoints for category and subcategory counts
        async fetchCategoryCounts() {
            const endpoint = 'competitor-detail/wettbewerber/category-counts';
            await this.fetchData(endpoint);
        },
        async fetchAccessoiresSortimentCounts() {
            const endpoint = 'competitor-detail/wettbewerber/accessoires-sortiment-counts';
            await this.fetchData(endpoint);
        },
        async fetchBekleidungSortimentCounts() {
            const endpoint = 'competitor-detail/wettbewerber/bekleidung-sortiment-counts';
            await this.fetchData(endpoint);
        },
        async fetchSchuheSortimentCounts() {
            const endpoint = 'competitor-detail/wettbewerber/schuhe-sortiment-counts';
            await this.fetchData(endpoint);
        },
        async fetchMarkenSortimentCounts() {
            const endpoint = 'competitor-detail/wettbewerber/marken-sortiment-counts';
            await this.fetchData(endpoint);
        },
        async fetchVerschiedenesSortimentCounts() {
            const endpoint = 'competitor-detail/wettbewerber/verschiedenes-sortiment-counts';
            await this.fetchData(endpoint);
        },
        async fetchSonstigesSortimentCounts() {
            const endpoint = 'competitor-detail/wettbewerber/sonstiges-sortiment-counts';
            await this.fetchData(endpoint);
        },
    },
    getters: {
        getEndpointData: (state) => (endpoint) => {
            return state.data[endpoint] || {};
        }
    },
});
